import React, {useContext} from 'react'
import {Route} from "react-router";
import {AppContext} from "../../context/app-context";
import {useFeatureFlags} from '../../hooks/routing/useFeatureFlags';
import {withAccessControl} from "../ProtectedRoute";
import AccessControlBuilder from "../AccessControlBuilder";

import SupplierInterchangeReport from '../../views/SupplierInterchangeReport';
import SupplierActivitySummaryReport from "../../views/supplier/SupplierActivitySummaryReport";
import CheckInLegacy from "../../views/CheckInLegacy";
import SupplierBookingCheckInReport from "../../views/supplier/SupplierBookingCheckInReport";
import SupplierCurrentInventoryReport from "../../views/supplier/SupplierCurrentInventoryReport";
import SupplierPendingInventoryActivityReport from '../../views/supplier/SupplierPendingInventoryActivityReport'

const allSupplierGmsAuthorization = new AccessControlBuilder().allowAllGmsUsers().build()

const ProtectedCheckInLegacy = withAccessControl(CheckInLegacy, allSupplierGmsAuthorization)
const ProtectedSupplierBookingCheckInReport = withAccessControl(SupplierBookingCheckInReport, allSupplierGmsAuthorization)
const ProtectedSupplierInventoryReport = withAccessControl(SupplierCurrentInventoryReport, allSupplierGmsAuthorization)
const ProtectedSupplierInterchangeReport = withAccessControl(SupplierInterchangeReport, allSupplierGmsAuthorization)
const ProtectedSupplierActivitySummaryReport = withAccessControl(SupplierActivitySummaryReport, allSupplierGmsAuthorization)
const ProtectedSupplierPendingInventoryActivityReport = withAccessControl(SupplierPendingInventoryActivityReport, allSupplierGmsAuthorization)

const GateManagementContent = (): React.ReactElement<any>[] => {
  const appContext = useContext(AppContext)
  const {logout} = appContext

  const {
    supplierPendingInventoryActivity
  } = useFeatureFlags();

  const flagGatedRoutes = [];
  if (supplierPendingInventoryActivity) {
    flagGatedRoutes.push(
      <Route path={"/supplier-pending-inventory-activity"} key={"/supplier-pending-inventory-activity"} element={
        <ProtectedSupplierPendingInventoryActivityReport handleLogout={logout}/>
      }/>
    )
  }

  return [
    <Route path="/check-in" key="/check-in" element={
              <ProtectedSupplierBookingCheckInReport />
    }/>,
    <Route path="/check-in/:bookingId" key="/check-in/bookingId" element={
              <ProtectedCheckInLegacy handleLogout={logout}/>
    }/>,
    <Route path="/supplier-inventory" key="/supplier-inventory" element={
              <ProtectedSupplierInventoryReport handleLogout={logout}/>
    }/>,
    <Route path={"/supplier-interchanges"} key={"/supplier-interchanges"} element={
              <ProtectedSupplierInterchangeReport handleLogout={logout}/>
    }/>,
    <Route path="/supplier-activity-summary" key="/supplier-activity-summary" element={
              <ProtectedSupplierActivitySummaryReport handleLogout={logout}/>
    }/>,
    ...flagGatedRoutes
  ]
}

export default GateManagementContent
